import * as React from 'react';
import {Button,Box} from '@mui/material';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import CircularProgress from "@mui/material/CircularProgress";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import getCookie, { setAdminCookie, userState } from '../../Atom';
import { deleteLaunchTrekFile } from '../LaunchtrakFligths/api'
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function DeleteFiles(props) {
    const [loading,setLoading]=React.useState(false)
    const handleClose = () => {
        props?.setOpen(false);
    };
    const logoutHandler = async () => {
        setTimeout(() => {
            // setmyUser({
            //   fName: null,
            //   userId: null,
            //   token: null,
            //   lName: null,
            // })
            setAdminCookie({
                fName: null,
                lName: null,
                token: null,
                userId: null
            })
            let hostname = window.location.host;
            window.location.assign(`${window.location.protocol}//${hostname}/super-admin`)
        })
    }
    const onDeleteLaunchTrekFile = async () => {
        const _cookie = getCookie('recoil-persist')
        if (!_cookie) {
            logoutHandler()
        } else {
            const user = JSON.parse(_cookie)['KT_app']
            if (props?.module === "deleteFromDevice") {
                props?.deleteFiles()
            } else {
                const res = await deleteLaunchTrekFile(props?.fileId, user.token);
                if (res.error) {
                    if (res.data.statusCode == 401) {
                        logoutHandler();
                    }
                } else {
                    props?.getLaunchData(user, props?.page, props?.pageLimit,props?.orderBy,props?.order)
                    props?.setSnackBarShow(true);
                    props?.setSnackBarMessage("Data Deleted successfully");
                    props?.setSnackBarSeverity("success");
                }
            }
        }

        handleClose()
    }
    const onDeletefileFromDevice = async () => {
        setLoading(true)
        props?.setCheckedFiles([])
        const data = await props?.deleteFilesFromDevice();
        if(data==='done'){ 
        setLoading(false);
        props?.setSnackBarShow(true);
        props?.setSnackBarMessage("Done deleting the file!");
        props?.setSnackBarSeverity("success");
        props?.setOpen(false);
        props?.handleClose()
    }
    }
    return (
        <React.Fragment>
            {/* <Button variant="outlined" onClick={handleClickOpen}>
                <DeleteOutlineOutlinedIcon />
            </Button> */}
            <BootstrapDialog
           
                style={{ alignItems: 'center !important' }}
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={props?.open}>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}>
                    <CloseIcon />
                </IconButton>
                <DialogContent  className={loading && "blur-content" }>
                    <div style={{ padding: 40, display: 'flex', flexDirection: 'column', gap: 20 }}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <div

                                style={{
                                    backgroundColor: "#E800001C",
                                    color: "#E80000",
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: 56, // Diameter of the button
                                    height: 56, // Diameter of the button
                                    borderRadius: "50%", // Makes the button circular
                                    '&:hover': { backgroundColor: "#E800001C" },
                                }}
                            >
                                <DeleteOutlineOutlinedIcon />
                            </div>
                        </div>
                        {props?.moduleDel === "deleteFromDevice" ? <div>
                            <Typography variant='h5' className="text-center">   Are you sure you want to delete everything on the SD card? [Y/n]</Typography>
                            <Typography gutterBottom className="text-center">
                                This will delete all files permanently from the device, not just selected ones.
                              
                                {/* Are you sure you want to delete everything on the SD card */}
                            </Typography>
                        </div>
                            :
                            <div>
                                <Typography variant='h5' className="text-center">  Are you sure to delete this file?</Typography>
                                <Typography gutterBottom className="text-center">
                                    This will delete this file permanently from the Database.
                                </Typography>
                            </div>
                        }
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant='outlined'
                        onClick={handleClose}
                        disabled={loading}
                        sx={{ textTransform: "none", alignItems:'center !important' }} >
                        No
                    </Button>
                    <Button variant="contained"
                        onClick={(e) => props?.moduleDel === "deleteFromDevice" ? onDeletefileFromDevice(e) : onDeleteLaunchTrekFile(e)}
                        sx={{ textTransform: "none", alignItems:'center !important' }}
                        disabled={loading}
                        className=' disabled:50'>
                        Yes
                    </Button>
                </DialogActions>
                {loading && (
            <Box
            style={{ alignItems: 'center !important' }}
              display="flex"
              flexDirection='column'
              gap={3}
              justifyContent="center"
              alignItems="center"
              className="loading-overlay"
            > <Typography>Deleting the file it may take a while to delete files</Typography>
              <CircularProgress />
            </Box>
          )}
            </BootstrapDialog>
              
        </React.Fragment>
    );
}